'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _templateObject = _taggedTemplateLiteral(['\n  top: 28px;\n\n  > div#listPanelItemContainer {\n    > div#addNewButton {\n      padding-left: ', ';\n    }\n\n    > div[name=\'listPanelOption\'] {\n      padding-left: ', ';\n    }\n  }\n'], ['\n  top: 28px;\n\n  > div#listPanelItemContainer {\n    > div#addNewButton {\n      padding-left: ', ';\n    }\n\n    > div[name=\'listPanelOption\'] {\n      padding-left: ', ';\n    }\n  }\n']);
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _ListPanel = require('../ListPanel/ListPanel');
var _ListPanel2 = _interopRequireDefault(_ListPanel);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var DropDownListPanel = (0, _styledComponents2['default'])(_ListPanel2['default'])(_templateObject, function (props) {
  return props.multiselect === true ? '8px' : '16px';
}, function (props) {
  return props.multiselect === true ? '0px' : '16px';
});
exports['default'] = DropDownListPanel;